import {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from 'react'
import Typography from '@mui/material/Typography'
import {
    ServiceCenterFormType,
} from 'app/Apps/ContainerManagement/ServiceCenters/serviceCenters.types'
import {
    ScenarioEditorContext,
} from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ScenarioEditorContext'
import useStyles from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ScenarioEditor.styles'
import {
    ScenarioEditorDataType,
} from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ScenarioEditor.types'
import ScenarioEditorForm from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ScenarioEditorForm'
import ForecastsByProduct
    from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ForecastsByProduct/ForecastsByProductProvider'
import ScenarioEditorAvailabilityChart
    from 'app/Apps/ContainerManagement/ServiceCenters/ScenarioEditor/ScenarioEditorAvailabilityChart'
import useLabel from 'app/hooks/useLabel'

import PreBookings from '../components/PreBookings'
import ContainerStatusBreakdown from './ContainerStatusBreakdown'
import OutboundOrders from './OutboundOrders'
import InboundOrders from './InboundOrders'
import ContainersDamaged from './ContainersDamaged'

const ServiceCentersDemoScenarioEditor = ({
    data,
}: Readonly<{
    data: ServiceCenterFormType
}>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const [
        value,
        setValue,
    ] = useState<ScenarioEditorDataType>()

    useEffect(() => {
        if (data && data?.id !== value?.serviceCenter?.id) {
            setValue({
                orderSelectionDelay: data?.orderSelectionDelay ?? 0,
                serviceCenter: {
                    id: data?.id,
                },
                includeNotStartedOrders: false,
                includePreBookings: false,
                productType: 'ALL',
                forecastsByProduct: [],
            })
        }
    }, [
        data,
        value?.serviceCenter?.id,
    ])

    const setContextValue = useCallback((newValue: Partial<ScenarioEditorDataType>) => {
        setValue({
            ...value,
            ...newValue,
        })
    }, [value])

    const context = useMemo(() => {
        return {
            contextValue: value,
            setContextValue,
        }
    }, [
        value,
        setContextValue,
    ])

    if (!value) return null

    return (
        <ScenarioEditorContext.Provider value={context}>
            <ScenarioEditorForm />
            <ForecastsByProduct />
            <ScenarioEditorAvailabilityChart />
            <Typography
                variant="h2"
                className={classes.title}
                sx={{
                    marginTop: 4,
                }}
            >
                {l('SUPPORT_INFORMATION')}
            </Typography>
            <ContainerStatusBreakdown serviceCenterId={data?.id} />
            <OutboundOrders serviceCenterId={data?.id} />
            <PreBookings serviceCenterId={data?.id} />
            <InboundOrders serviceCenterId={data?.id} />
            <ContainersDamaged serviceCenterId={data?.id} />
        </ScenarioEditorContext.Provider>
    )
}

export default ServiceCentersDemoScenarioEditor
